import { BrowserRouter as Router } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/material';
import { Provider } from 'react-redux';
import React from 'react';

import TitleContextProvider from './TitleContext';
import ToasterProvider from './ToasterProvider';

import store from 'store/configureStore';

const AppProvider = ({ children }) => {
  return (
    <Provider store={store}>
      <TitleContextProvider>
        <Router>
          <StyledEngineProvider injectFirst>
            <ToasterProvider />
            {children}
          </StyledEngineProvider>
        </Router>
      </TitleContextProvider>
    </Provider>
  );
};

export default AppProvider;
